// @flow
import * as React from 'react';

interface Props {
  onUsernameNeedleChange: (needle: string) => void
  onCheckboxToggle: () => void
  needle: string
  isCurrentProjectChecked: boolean
}

export const SearchUserForm = (props: Props) => {
  const { onUsernameNeedleChange, needle, isCurrentProjectChecked, onCheckboxToggle } = props

  const handleChange = (e) => {
    const { value } = e.target
    onUsernameNeedleChange(value)
  }
  
  return (
    <div className="user-row user-row-header">
      <div>
        <div className="col s6">
          <input
            type="text"
            placeholder="Search User Name"
            value={needle}
            onChange={handleChange}
          />
        </div>
        <div
          className="col s6 right-align"
          style={{ paddingTop: "1rem", paddingRight: "2rem" }}
        >
          <div className="switch project" style={{ display: "block" }}>
            <label style={{ verticalAlign: "middle" }}>
              All Users
              <input type="checkbox" checked={isCurrentProjectChecked} onChange={onCheckboxToggle} />
              <span className="lever" />
              Users in Current Project
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
